






























































































































import { StoreConstants, TaskServiceHostModel, TaskServiceHostServiceModel, TaskServiceSettingsConfigurationModel, ValueType, MStoreInputType } from '@/types';
import Vue from 'vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreFormGroup from '@/components/shared/MStoreFormGroup.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import { confirmationHelper } from '@/mixins';
import { BvTableFieldArray } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'HostsConfiguration',
  mixins: [confirmationHelper],
  props: {
    allHosts: {
      type: Array as () => TaskServiceHostModel[],
      required: true
    },
    value: {
      type: Array as () => TaskServiceHostServiceModel[],
      required: true
    },
    taskServiceConfiguration: {
      type: Object as () => TaskServiceSettingsConfigurationModel,
      required: true
    }
  },
  data() {
    return {
      searchQuery: '',
      currentPage: 1,
      isAddModalShown: false,
      hostServiceToAdd: {} as TaskServiceHostServiceModel
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession]),
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    queueName() {
      return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskService.queueName;
    },
    jobQueueName() {
      return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskService.jobQueueName;
    },
    queueHost: {
      get() {
        return (this.value as TaskServiceHostServiceModel[]).find((x) => x.queueName === this.queueName) ?? null;
      },
      set(updatedQueueHostService: TaskServiceHostServiceModel) {
        const currentValue = [...this.value] as TaskServiceHostServiceModel[];
        const updatedHosts = [{ ...updatedQueueHostService, queueName: this.queueName }, ...currentValue.filter((x) => x.queueName !== this.queueName)];
        this.$emit('input', updatedHosts);
      }
    },
    queueHostName: {
      get() {
        return (this.queueHost as TaskServiceHostServiceModel)?.hostName ?? null;
      },
      set(this: any, updatedHostName: string) {
        this.queueHost = {
          queueName: this.queueName,
          hostName: updatedHostName,
          workers: 1
        } as TaskServiceHostServiceModel;
      }
    },
    jobQueueHosts: {
      get() {
        const serviceJobHosts = (this.value as TaskServiceHostServiceModel[]).filter((x) => x.queueName === this.jobQueueName);
        return [...serviceJobHosts];
      },
      set(serviceJobHosts: TaskServiceHostServiceModel[]) {
        const currentValue = [...this.value];
        this.$emit('input', [...currentValue.filter((x) => x.queueName !== this.jobQueueName), ...serviceJobHosts]);
      }
    },
    availableServiceJobHosts(this: any) {
      return (this.allHosts as TaskServiceHostModel[]).filter(
        (host) => !(this.value as TaskServiceHostServiceModel[]).find((hostService) => hostService.hostName === host.hostName && hostService.queueName === this.jobQueueName)
      );
    },
    hostServiceToAddAuto: {
      get(this: any) {
        return ((this.hostServiceToAdd as TaskServiceHostServiceModel)?.workers ?? 0) === 0;
      },
      set(this: any, auto: boolean) {
        Vue.set(this.hostServiceToAdd as TaskServiceHostServiceModel, 'workers', auto ? 0 : 1);
      }
    },
    hostServiceToAddWorkers: {
      get(this: any) {
        return (this.hostServiceToAdd as TaskServiceHostServiceModel).workers.toString();
      },
      set(this: any, workers: string) {
        Vue.set(this.hostServiceToAdd as TaskServiceHostServiceModel, 'workers', workers === '' ? '' : Number(workers));
      }
    },
    hostServiceToAddWorkersValidation(this: any) {
      return {
        required: true,
        minValue: 1,
        maxValue: 20,
        valueType: ValueType.Integer
      } as ValidationModel;
    },
    restartWhenMemoryLimitExceeded: {
      get(this: any) {
        return (this.hostServiceToAdd as TaskServiceHostServiceModel).restartWhenMemoryLimitExceeded ?? false;
      },
      set(this: any, value: boolean) {
        Vue.set(this.hostServiceToAdd as TaskServiceHostServiceModel, 'restartWhenMemoryLimitExceeded', value);
      }
    },
    memoryLimitMb: {
      get(this: any) {
        return (this.hostServiceToAdd as TaskServiceHostServiceModel).memoryLimitMb ?? 0;
      },
      set(this: any, value: number) {
        Vue.set(this.hostServiceToAdd as TaskServiceHostServiceModel, 'memoryLimitMb', value);
      }
    },
    numberInputType() {
      return MStoreInputType.Number;
    },
    memoryLimitValidation(this: any) {
      if (this.restartWhenMemoryLimitExceeded) {
        return {
          required: true,
          minValue: this.MINIMUM_MEMORY_LIMIT_MB,
          maxValue: this.MAXIMUM_MEMORY_LIMIT_MB,
          valueType: ValueType.Integer
        } as ValidationModel;
      }
      return {
        required: false,
        valueType: ValueType.Integer
      } as ValidationModel;
    }
  },
  methods: {
    async onClickDeleteServiceJobHost(this: any, hostName: string) {
      const confirmation = await this.hasDeleteConfirmedAsync(this.$bvModal);
      if (!confirmation) {
        return;
      }
      const currentJobQueueHosts = [...this.jobQueueHosts];
      this.jobQueueHosts = [...currentJobQueueHosts.filter((x) => x.hostName !== hostName)];
    },
    onClickAdd(this: any) {
      this.hostServiceToAdd = { ...this.DEFAULT_SERVICE_HOST };
      this.isAddModalShown = true;
    },
    async onClickSaveNewHostService(this: any) {
      const isValid = await this.$refs.addServiceHostObserver.validate();
      if (!isValid) {
        return;
      }
      const currentValue = [...this.value];
      this.$emit('input', [...currentValue, this.hostServiceToAdd]);
      this.isAddModalShown = false;
    },
    async onCancelAddServiceJobHost(this: any, dirty: boolean) {
      if (await this.hasUnsavedChangesToKeepAsync(this.$bvModal, dirty)) {
        return;
      }
      this.isAddModalShown = false;
    }
  },
  created(this: any) {
    this.SERVICE_JOB_HOST_FIELDS = [
      {
        key: 'hostName',
        label: 'Host Name',
        formatter: (value: string) => value + ((this.allHosts as TaskServiceHostModel[]).findIndex((x) => x.hostName === value) === -1 ? ' (Deleted)' : '')
      },
      { key: 'workers', label: 'Workers Threads', formatter: (value: number) => value || 'Auto' },
      { key: 'restartWhenMemoryLimitExceeded', label: 'Restart When Memory Limit Exceeded', formatter: (value: boolean) => (value ? 'Yes' : 'No') },
      { key: 'memoryLimitMb', label: 'Memory Limit (Mb)', formatter: (value: number) => value || '' },
      { key: 'actions', label: '', class: 'action-element' }
    ] as BvTableFieldArray;
    this.WORKERS_VALIDATION = { minValue: 0, required: true, valueType: ValueType.Integer } as ValidationModel;
    this.DEFAULT_SERVICE_HOST = {
      queueName: (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskService.jobQueueName,
      workers: 0
    } as TaskServiceHostServiceModel;
    this.MINIMUM_MEMORY_LIMIT_MB = 100;
    this.MAXIMUM_MEMORY_LIMIT_MB = 8000;
  },
  components: {
    MStoreFormCheckbox,
    MStoreTable,
    MStoreFormInput,
    MStoreFormGroup,
    MStoreFormSelect
  }
});
